// ...existing code...
import { Component ,Input,ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators, FormGroup } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {MatTabsModule} from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';




import { LbnContainerComponent, CheckboxesComponent,LbnInputFieldComponent ,TitleComponent ,LbnAccordianComponent,InputDropdownComponent ,DataPickerComponent ,
  FormActionsButtonsComponent,LbnActionButtonComponent,RadioButtonsComponent} from '../../shared/components';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; 
@Component({
  selector: 'app-billing',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,MatTableModule,
    MatIconModule,LbnContainerComponent,LbnInputFieldComponent,
    DataPickerComponent,InputDropdownComponent ,
    LbnAccordianComponent ,TitleComponent ,MatDatepickerModule ,
     FormActionsButtonsComponent,LbnActionButtonComponent ,RadioButtonsComponent,
     CheckboxesComponent ,MatTabsModule ,MatSelectModule,MatCheckboxModule ,MatNativeDateModule 
  ],
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.scss']
})
export class BillingComponent {
   @ViewChild('ownerRadios') ownerRadios?: RadioButtonsComponent;

 billingForm: FormGroup;
   @Input() title = 'Billing details';
  @Input() subTitle = 'Licensing details';
   categories = [
    { name: 'Standard' },
    { name: 'Premium' },
    { name: 'Enterprise' },
  ];
    instanceslist = [
    { name: 'Cape Town' },
    { name: 'Durban' },
    { name: 'Johannesburg' },
  ];
  clienttypes = [
 
  { name: 'Bureau' },
  { name: 'Channel' },
  { name: 'Direct' },
  { name: 'Indirect' },

];
licensetypes = [
  { name: 'Hosted/Internet' },
  { name: 'Intranet/Standalone' }
];
regions = [
  { name: 'Eastern Cape' },
  { name: 'Free State' },
  { name: 'Gauteng' },
  { name: 'Kwazulu-Natal' },
  { name: 'Limpopo' },
  { name: 'Mpumalanga' },
  { name: 'Northern Cape' },
  { name: 'North West' },
  { name: 'Western Cape' }
];
servicetypes = [
  { name: 'Outsource' },
  { name: 'Supported / Payroll' },

];
branches = [
  { name: 'Cape Town' },
  { name: 'Port Elizabeth' },
  { name: 'Durban' },
  { name: 'East London' },
  { name: 'Bloemfontein' },
  { name: 'Joburg South' },
  { name: 'Pretoria' },
  { name: 'Joburg north' },
  { name: 'George' },
  { name: 'Nelspruit' },
  { name: 'Rustenburg' },
  { name: 'Zulu Land' },
  { name: 'Potchefstroom' },

];
deactivationreasons = [
  { name: 'Cancelled' },
 
  { name: 'Other' }
];
anniversarymonths = [
  { name: 'January' },
  { name: 'February' },
  { name: 'March' },
  { name: 'April' },
  { name: 'May' },
  { name: 'June' },
  { name: 'July' },
  { name: 'August' },
  { name: 'September' },
  { name: 'October' },
  { name: 'November' },
  { name: 'December' }
];
billingtypes = [
  { name: 'Usage' },
  { name: 'Product' },
  { name: 'Non-Billable' }
];


  isLoading = false;
   updateButtons:    {
      label: string,
      position: string,
      action: Function
    }[] = [];
    
     clientOwnerButtons = [
    { value: 'LPS' },
    { value: 'Psiber' }
  ];
    // For the new checkboxes
  noticeOptions = [
    { label: 'Newsletters' },
    { label: 'Upgrades' },
    { label: 'Standalone Notices' },
    { label: 'PSiber Notices' },
     { label: 'Statutory Notices' },
  ];


   isGroupCompanyOptions = [
    { label: 'Is Group Company' },
  
  ];
  
   isunlimitedOptions = [
    { label: 'unlimited' },
  
  ];
  expiryOptions = [
    { label: 'No Expiry' },
  
  ];
  relationshipOptions = [
      { label: 'Labournet Client' },
     { label: 'Affiliate Client' },
    { label: 'Bureau Client' },

  ];
   licenseTypes = [
      { name: 'Hosted/Internet' },
     { name: 'Intranet/Standalone' },
    { name: 'Bureau Client' },

  ];
 
  productOptions = [
    { product: 'Standard', expiryDate: 'Jan', accessTypes: 'Live / Full Access' },
    { product: 'Premium', expiryDate: 'Feb', accessTypes: 'Offline / Limited Access' },
    { product: 'Enterprise', expiryDate: 'Mar', accessTypes: 'Full Control' }
  ];
  selectedProduct: any;
selectedTabIndex = 0; 
companyRegistration!:string;

 selectedProducts: any[] = [];
  //displayedColumns = ['product', 'expiryDate', 'accessTypes'];
displayedColumns: string[] = ['product', 'expiryDate', 'accessTypes'];

  // Sample data
  productOption = [
    { id: 1, name: 'PSIberPAY' },
    { id: 2, name: 'Performance Management' },
    { id: 3, name: 'Training Management' }
  ];

  accessTypeOptions = ['Live/Full Access', 'View/Print Only', 'Demo'];

  constructor(private fb: FormBuilder) {
    // initialize form in constructor to avoid using injected service before initialization
    this.billingForm = this.fb.group({
       product: [null],
      expiryDate: [null],
      accessTypes: [null],
      //Licence details
      companyName: ['', [Validators.required]],
      previouseName: ['', Validators.required],
      // companyRegistration: [{ value: '', disabled: true }],
        companyRegistration: [{ value: 'ABC123', disabled: true }],
      //companyRegistration: ['', [Validators.required] ,[disabled]: true ],
      clientName: ['', Validators.required],
      licenseType: [''],
      instance: ['', Validators.required],
      groupCompany: ['', Validators.required],
     
      registrationDate: ['', Validators.required],
       joiningDate: ['', Validators.required],
      //contracts details
      
      productLicence: ['', [Validators.required]],
      dealership: ['', Validators.required],
     serviceProvide: ['', Validators.required],
      hosting: ['', Validators.required],
      category: [''], // new dropdown field // 🆕 added
      //client details
      
      clientType: ['', [Validators.required]],
      serviceType: ['', Validators.required],
     region: ['', Validators.required],
      branch: ['', Validators.required],
      deactivationDate: [''], // new dropdown field // 🆕 added
       deactivationReason: ['', Validators.required],
        administrator: ['', Validators.required],
       salesperson: ['', [Validators.required]],
      cre: ['', Validators.required],
      comments: [''], // new dropdown field // 🆕 added


      //licence details
      
     // product: ['', [Validators.required]],
      AccessType: ['', Validators.required],
    //expiryDate: ['', Validators.required],
       noExpiry: ['', Validators.required],
      activeEmployees: [''], // new dropdown field // 🆕 added
       totalEmployees: ['', Validators.required],
        payslipsPerInterval: ['', Validators.required],
     
      //Contact Info
      
      contactEmail: ['', [Validators.required]],
      contactEmailOther: ['', [Validators.required]],
      telephone: ['', Validators.required],
    cellular: ['', Validators.required],
    //physical address
     unitNumber: ['', Validators.required],
      complexName: ['', Validators.required],
      streetnumber: ['', Validators.required],
      streetAddress: ['', [Validators.required]],
      suburb: ['', Validators.required],
      city: ['', Validators.required],
      zipCode: ['', Validators.required],
       province: ['', Validators.required],
      //postal address
      
      line1: ['', Validators.required],
      line2: [''],
      line3: [''],
      postalCode: ['', Validators.required],
       Country: ['', Validators.required],
      //Payment/Billing Info
       anniversaryMonth: ['', [Validators.required]],
      billingUsage: ['', [Validators.required]],
      works: ['', Validators.required],
    pay: ['', Validators.required],
      hra: ['', Validators.required],
      hrm: [''], // new dropdown field // 🆕 added
       ess: ['', Validators.required],
        conversion: ['', Validators.required]
    });
  }
   
       ngOnInit(): void {
  
    this.updateButtonsValues();
    this.companyRegistration='Jwa12345';
   // disable later
this.billingForm.get('companyRegistration')?.disable();

// enable later
this.billingForm.get('companyRegistration')?.enable();
  }
 addProduct() {
    const { product, expiryDate, accessTypes } = this.billingForm.value;

    // Prevent empty entries
    if (!product || !expiryDate || !accessTypes) {
      console.warn('Please select all product fields');
      return;
    }

    const newProduct = { product, expiryDate, accessTypes };
    this.selectedProducts = [...this.selectedProducts, newProduct];

    // Reset only product-related fields, not company info
    this.billingForm.patchValue({
      product: null,
      expiryDate: null,
      accessTypes: null
    });

    console.log('Products list:', this.selectedProducts);
  }
  
  updateButtonsValues(){
    this.updateButtons = [
    
 
    {
      label: 'Save',
      position: 'right',
      action: () => this.onSubmit(),
    },
    ]
  }
    onBack(): void {
    }
  onSubmit(): void {
    if (this.billingForm.invalid) {
      this.billingForm.markAllAsTouched();
      return;
    }
    this.isLoading = true;
    // replace with real auth call
    setTimeout(() => {
      this.isLoading = false;
      console.log('login', this.billingForm.value);
    }, 800);
  }
    onCategorySelect(value: any) {
    console.log('Selected category:', value);
  }
  //   onClientOwnerChange(value: string) {
  //   console.log('Client owner selected:', value);
  //   // apply value to your form or state, e.g. this.billingForm.patchValue({ owner: value });
  // }

  // example: programmatically select an option (call from a button or lifecycle hook)
  selectPsiber() {
   // this.ownerRadios?.selectOption('Psiber');
  }
   onClientOwnerChange(selected: string) {
    console.log('Client owner selected:', selected);
  }
    onCheckboxSelectionChange(selectedOptions: string[]) {
    console.log('Selected notices:', selectedOptions);
  }
   ongroupCompanyChange(selectedOptions: string[]) {
    console.log('Selected notices:', selectedOptions);
  }
  onRelationshipSelectionChange(selectedOptions: string[]) {
    console.log('Selected notices:', selectedOptions);
  }
    onExpirySelectionChange(selectedOptions: string[]) {
    console.log('Selected notices:', selectedOptions);
  }
    selectItem(item: any) {
    this.selectedProduct = item;
  }

  onSelectionChange(event: any) {
    // Optional: handle when selection changes
  }

  compareProducts(a: any, b: any) {
    return a && b && a.product === b.product;
  }

}
// ...existing code...